import { connect, mapProps, useField } from "@formily/react";
import { getConfigValue } from "@rumble-it/common-lib/src/config";
import { Button } from "./Button";

const CDN_URL = getConfigValue("cdnUrl");

interface ActOfCessionProps {
  // Form-related props
  value?: string | null;
  onChange?: (actofcession: string) => void;
  errors?: Array<{ messages: string[] }>;

  // Component behavior props
  imagePath?: string;
  downloadPath?: string;
  downloadLabel?: string;
}

export const ActOfCessionExample = (props: ActOfCessionProps) => {
  const field = useField();
  const title = field?.title || "Voorbeelddocument";

  const imagePath =
    props.imagePath || `${CDN_URL}/static/dealer-intake/document.svg`;
  const downloadPath =
    props.downloadPath || `${CDN_URL}/static/akte-van-cessie.pdf`;
  const downloadLabel = props.downloadLabel || `Download akte van cessie`;

  return (
    <div className="md:mt-8">
      <div className="border border-neutral-300 hover:border-neutral-400 rounded-md p-4 flex flex-col gap-4">
        <h3 className="text-md text-center p-2">{title}</h3>
        <img
          alt="Document"
          loading="lazy"
          src={imagePath}
          className="max-w-24 max-h-24 mx-auto block"
          style={{ width: "auto", height: "auto" }}
        />
        <Button
          type="primary"
          className="w-full"
          href={downloadPath}
          target="_blank"
          rel="noopener noreferrer"
        >
          {downloadLabel}
        </Button>
      </div>
    </div>
  );
};

export const RumbleActOfCessionExample = connect(
  ActOfCessionExample,
  mapProps((props: ActOfCessionProps, field: any) => {
    return {
      ...props,
      value: props.value,
      onChange: props.onChange,
      invalid: field?.valid === false,
      errors: field?.errors,
    };
  }),
);

export default RumbleActOfCessionExample;
